<script setup lang="ts">
const config = useRuntimeConfig();

const { $sanitizeHtml } = useNuxtApp();

provide("sanitize", $sanitizeHtml);

useHead({
  link: [
    {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: `${config.public.pngSize16}`
    },
    {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: `${config.public.pngSize32}`
    },
    {
      rel: "apple-touch-icon",
      type: "image/png",
      sizes: "180x180",
      href: `${config.public.pngSize180}`
    }
  ],
  meta: [{ property: "fb:admins", content: `${config.public.socialfbAdmin}` }]
});
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
